import ResourcesCollectionProto from "./resources-collection-proto"
import Task from "../../model2/task/task"
import Resources from "../resources"
import TimeReportsCollection from "../../model2/time-report/collection"
import {UpdateAction, UpdateType} from "../../gd/manager/delta-handler/types"
import TimeReportsResourcesCollection from "./time-reports";

// const debug = "TasksResourcesCollection"
const debug = false

export default class TasksResourcesCollection extends ResourcesCollectionProto {
    constructor(resources:Resources, data: any[] = [], options:any = {}) {
        super(resources, data, Task, options)
    }

    resetTimeReports() {
        _.map(this.models, (task:Task)=>{
            task.timeReports.reset()
        })
    }

    linkTimeReports(timeReportsCollection: TimeReportsCollection | TimeReportsResourcesCollection | null) {

        if (!TimeReportsCollection) return

        // @ts-ignore
        _.map(timeReportsCollection.models, (timeReport)=>{

            let task

            // patch
            if (timeReport.taskId) {
                task = this.get(timeReport.taskId)
            }

            if (timeReport.task?.id) {
                task = this.get(timeReport.task.id)
            }

            if (task) {
                task.timeReports.add(timeReport)
                timeReport.task = task
            }
        })
    }

    resetCostFields() {
        _.map(this.models, (task:Task)=>{
            task.resetCostFields()
        })
    }

    processUpdate(update:UpdateAction):boolean {
        debug && console.log(debug, "processUpdate()", update)

        // New
        if (update.updateType === UpdateType.TASK_NEW) {

            const task : Task = new Task(update.payload)
            this.add(task)

            return true // collection changed
        }

        // Change/Delete
        const task: Task | undefined = this.get(update.payload.id)

        // not found ? -> no update
        if (!task) {
            return false
        }

        if (update.updateType === UpdateType.TASK_DELTA) {
            return task.applyDelta(update.payload)
        }

        if (update.updateType === UpdateType.TASK_DELETE) {
            this.remove(update.payload.id)
            return true // deleted = changed
        }

        // should never get heres
        return false // not changed
    }
}